import { render, staticRenderFns } from "./new-candidate-bluelynx-account.vue?vue&type=template&id=d2c2916c&"
import script from "./new-candidate-bluelynx-account.vue?vue&type=script&lang=js&"
export * from "./new-candidate-bluelynx-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports